// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SidebarController from "../../components/admin/layouts/sidebar_controller"
application.register("admin--layouts--sidebar", SidebarController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BatchSelectionController from "./batch_selection_controller"
application.register("batch-selection", BatchSelectionController)

import ChoicesjsController from "./choicesjs_controller"
application.register("choicesjs", ChoicesjsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CommaNumberController from "./comma_number_controller"
application.register("comma-number", CommaNumberController)

import HeaderController from "../../components/customers/layouts/header_controller"
application.register("customers--layouts--header", HeaderController)

import DocumentCheckController from "./document_check_controller"
application.register("document-check", DocumentCheckController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FundSettlementPreviewController from "./fund_settlement_preview_controller"
application.register("fund-settlement-preview", FundSettlementPreviewController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HolidayEditorController from "./holiday_editor_controller"
application.register("holiday-editor", HolidayEditorController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import KenallController from "./kenall_controller"
application.register("kenall", KenallController)

import LoanDefaultsController from "./loan_defaults_controller"
application.register("loan-defaults", LoanDefaultsController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ScrollTabsController from "./scroll_tabs_controller"
application.register("scroll-tabs", ScrollTabsController)

import SimulationController from "./simulation_controller"
application.register("simulation", SimulationController)

import SlugPreviewController from "./slug_preview_controller"
application.register("slug-preview", SlugPreviewController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
